export const IS_WEBOS = process.env.WEBOS_BUILD === 'true';
